<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2"><h3 class="content-header-title mb-0">
                {{ isEditing ? `Edit Order (${order.order_number})` : 'Create Order' }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item"><a href="/admin/orders">Orders</a></li>
                            <li class="breadcrumb-item active">{{ isEditing ? 'Edit Order' : 'Create Order' }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <form @submit.prevent="isEditing ? updateOrder() : createOrder()" class="create-order-form">
                                <h4 class="form-section"><i class="feather icon-info"></i> Order Details </h4>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card-group">
                                            <div class="card-group__title">General</div>
                                            <div class="card-group__body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group"><label for="">Delivery Type</label>
                                                            <div class="d-flex align-items-center">
                                                                <fieldset class="radio"><label> <input type="radio"
                                                                                                       name="delivery-type"
                                                                                                       v-model="order.order_type"
                                                                                                       @click="order.payment_method = ''"
                                                                                                       value="delivery">
                                                                    Delivery </label></fieldset>
                                                                <fieldset class="radio ml-2"><label> <input type="radio"
                                                                                                            name="delivery-type"
                                                                                                            v-model="order.order_type"
                                                                                                            @click="order.payment_method = 'WebPay'"
                                                                                                            value="pickup">
                                                                    Pickup from store </label></fieldset>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="">Choose Location</label>
                                                            <div class="input-group mb-3" v-if="!showAddressInput">
                                                                <input type="text" :value="order.street" disabled
                                                                       class="form-control form-control-sm">
                                                                <div class="input-group-append" @click="editAddress">
                                                                    <span class="input-group-text" id="basic-addon2"><i
                                                                        class="fa fa-edit"></i></span></div>
                                                            </div> <!-- :component-restrictions='{country: ["ng"]}'-->
                                                            <!-- :libraries="['places', '&language=en&region=NG']"-->
                                                            <place-autocomplete-field v-model="field1"
                                                                                      v-show="showAddressInput"
                                                                                      name="field2"
                                                                                      api-key="AIzaSyDsOQjjlhshSlZ42nocaWY2ly9fdXcB8A8"
                                                                                      placeholder="Enter an an address, zipcode, or location"
                                                                                      @autocomplete-select="addressAutocompleteSearch"></place-autocomplete-field>
                                                             </div>
                                                    </div>
                                                    <div class="col-md-6" v-if="user.user_type !== 'store manager'">
                                                        <div class="form-group">
                                                            <label for="">Choose Restaurant</label>
                                                            <v-select class="customer-search" label="name"
                                                                      v-model="order.restaurant" :options="restaurants">
                                                                <template slot="no-options"> Choose restaurant
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center"><span>{{ option.name }}</span><br/>
                                                                        <small>{{ option.address }}, {{
                                                                                option.city.city
                                                                            }}</small></div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center"><span>{{
                                                                            option.name
                                                                        }}</span></div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                    <div class="col-12" v-if="outOfCoverageMessage"><span
                                                        class="badge badge-danger"> {{ outOfCoverageMessage }} </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6"
                                         v-if="isEditing || (order.order_type && order.restaurant && hasLocation && !outOfCoverageMessage)">
                                        <div class="card-group">
                                            <div class="card-group__title">Customer Details</div>
                                            <div class="card-group__body">
                                                <div class="row" v-if="!isEditing">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <div class="controls"><label>New Customer?</label>
                                                                <switches
                                                                    class="form-control form-control-sm new-customer"
                                                                    v-model="newCustomer" theme="bulma"></switches>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6" v-if="!newCustomer">
                                                        <div class="form-group"><label
                                                            for="customer-search">Customer</label>
                                                            <v-select id="customer-search" class="customer-search"
                                                                      label="name" v-model="order.customer"
                                                                      :filterable="false" :options="customers"
                                                                      @search="onSearch">
                                                                <template slot="no-options"> Search by Phone number
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center"><small> {{ option.email }},
                                                                        {{ option.phone }} </small> <br/> <span> {{
                                                                            option.first_name + ' ' + option.last_name
                                                                        }} </span></div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center"><span> {{
                                                                            option.first_name + ' ' + option.last_name
                                                                        }} </span></div>
                                                                </template>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <template v-if="newCustomer || (order.customer.first_name)">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label for="first_name">First
                                                                Name</label> <input id="first_name" type="text"
                                                                                    :disabled="!!isEditing"
                                                                                    v-model="order.customer.first_name"
                                                                                    class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label for="last_name">Last
                                                                Name</label> <input id="last_name" type="text"
                                                                                    :disabled="!!isEditing"
                                                                                    v-model="order.customer.last_name"
                                                                                    class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label for="email">Email
                                                                Address</label> <input id="email" type="text"
                                                                                       :disabled="!!isEditing"
                                                                                       v-model="order.customer.email"
                                                                                       class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label for="phone">Phone</label>
                                                                <input id="phone" type="text" :disabled="!!isEditing"
                                                                       v-model="order.customer.phone"
                                                                       class="form-control form-control-sm"></div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6"
                                         v-if="isEditing || (order.order_type && order.restaurant && order.latitude && order.longitude && !outOfCoverageMessage)">
                                        <div class="card-group">
                                            <div class="card-group__title">
                                                {{ order.order_type === 'delivery' ? "Billing & Shipping" : 'Billing' }}
                                            </div>
                                            <div class="card-group__body">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="payment-method">Payment
                                                            Method</label> <select id="payment-method"
                                                                                   v-model="order.payment_method"
                                                                                   class="form-control form-control-sm"
                                                                                   :disabled="order.paid === 1">
                                                            <option value="">Select payment method</option>
                                                            <option v-for="method in paymentMethods" :key="method.id"
                                                                    :value="method.method"> {{ method.method }}
                                                            </option>
                                                        </select> <span v-if="paymentMethodError" class="text-danger"> Please select a payment method </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="date-created">Created
                                                            At</label> <input id="date-created" type="datetime-local"
                                                                              v-model="order.created_at"
                                                                              class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                                <template v-if="order.order_type === 'delivery'">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label for="house-no">House
                                                                Number</label> <input id="house-no" type="text"
                                                                                      v-model="order.customer.house_number"
                                                                                      class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label
                                                                for="longitude">Longitude</label> <input id="longitude"
                                                                                                         type="text"
                                                                                                         v-model="order.longitude"
                                                                                                         disabled
                                                                                                         class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group"><label
                                                                for="latitude">Latitude</label> <input id="latitude"
                                                                                                       type="text"
                                                                                                       v-model="order.latitude"
                                                                                                       disabled
                                                                                                       class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6"
                                         v-if="isEditing || (order.order_type && order.restaurant && hasLocation && !outOfCoverageMessage)">
                                        <div class="card-group">
                                            <div class="card-group__title">Recipient Details</div>
                                            <div class="card-group__body">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="first_name_recipient">First
                                                            Name</label> <input id="first_name_recipient" type="text"
                                                                                v-model="order.recipient.first_name"
                                                                                class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="last_name_recipient">Last
                                                            Name</label> <input id="last_name_recipient" type="text"
                                                                                v-model="order.recipient.last_name"
                                                                                class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label for="email_recipient">Email
                                                            Address</label> <input id="email_recipient" required
                                                                                   type="text"
                                                                                   v-model="order.recipient.email"
                                                                                   class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group"><label
                                                            for="phone_recipient">Phone</label> <input
                                                            id="phone_recipient" type="text"
                                                            v-model="order.recipient.phone"
                                                            class="form-control form-control-sm"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6"
                                         v-if="isEditing || (order.order_type && order.restaurant && order.latitude && order.longitude && !outOfCoverageMessage)">
                                        <div class="card-group">
                                            <div class="card-group__title">Order Note</div>
                                            <div class="card-group__body">
                                                <div class="row mt-2">
                                                    <div class="col-md-12">
                                                        <div class="form-group"><textarea id="order-note"
                                                                                          v-model="order.order_note"
                                                                                          rows="2"
                                                                                          class="form-control form-control-sm"
                                                                                          placeholder="Customer notes about the order"/>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-md-12" v-for="(item, index) in order.order_note"-->
                                                    <!-- :key="item.id">--> <!-- <div class="form-group">-->
                                                    <!-- <textarea id="order-note" v-model="item.note"-->
                                                    <!-- rows="2"--> <!-- class="form-control form-control-sm"-->
                                                    <!-- placeholder="Customer notes about the order">-->
                                                    <!-- </textarea>--> <!-- </div>--> <!-- </div>--> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h4 class="form-section"
                                    v-if="isEditing || (order.order_type && order.restaurant && order.latitude && order.longitude && !outOfCoverageMessage)">
                                    <i class="feather icon-shopping-cart"></i> Order Items
                                    <button @click="showOrderItems = !showOrderItems"
                                            class="btn btn-sm btn-outline-primary pull-right float-right" type="button"
                                            v-if="isEditing || (order.longitude && order.restaurant && !outOfCoverageMessage)">
                                        <i class="feather icon-plus-circle icon-left"></i> Add Item(s)
                                    </button>
                                </h4>
                                <form @submit.prevent="addItems" v-if="showOrderItems">
                                    <div class="modal-body" v-if="order.restaurant">
                                        <div class="row" v-for="(item, index) in order.order_items" :key="item.id">
                                            <div class="col-md-3">
                                                <div class="form-group"><label>Product</label> <br>
                                                    <v-select class="order-items-search" label="name"
                                                              v-model="item.product" :options="restaurantProducts"
                                                              max-height="50px">
                                                        <template slot="no-options"> Choose Product</template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center"
                                                                 v-if="option.product.product_type === 'simple'"><img
                                                                :src="option.product.image_url" width="40px"> <span
                                                                class="ml-1">{{ option.product.product }}</span> <span
                                                                class="ml-1"> ₦ {{
                                                                    formatNumber(getProductPrice(option))
                                                                }} </span></div>
                                                            <div class="d-center" v-else><img
                                                                :src="option.product.image_url" width="40px"> <span
                                                                class="ml-1">{{ option.product.product }}</span></div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center"><img
                                                                :src="option.product.image_url" height="28px"> <span
                                                                class="ml-1">{{ option.product.product }}</span></div>
                                                        </template>
                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-3"
                                                 v-if="!isEditing && item.product && item.product.product_type === 'variable' && item.product.product.product_variations && item.product.product.product_variations.length > 0">
                                                <label> Choose {{
                                                        item.product.product.product_variations[0].variable_name
                                                    }} </label> <select class="form-control"
                                                                        @change="setVariableCost(index)"
                                                                        v-model="item.selected_variation" required>
                                                <option> Select
                                                    {{ item.product.product.product_variations[0].variable_name }}
                                                </option>
                                                <option
                                                    v-for="(variation, index) in parseJson(item.product.product.product_variations[0].variations)"
                                                    :key="index"
                                                    :value="`${variation.name}-${variation.sale_price || variation.price}`">
                                                    {{ variation.name }} (₦ {{
                                                        variation.sale_price || variation.price
                                                    }})
                                                </option>
                                            </select></div>
                                            <div class="col-md-3"
                                                 v-if="isEditing && item.product && item.product.product_type === 'variable' && item.product_variations && item.product_variations.length > 0">
                                                <label> Choose {{ item.product_variations[0].variable_name }} </label>
                                                <select class="form-control" @change="setVariableCost(index)"
                                                        v-model="item.selected_variation" required>
                                                    <option> Select {{
                                                            item.product_variations[0].variable_name
                                                        }}
                                                    </option>
                                                    <option
                                                        v-for="(variation, index) in parseJson(item.product_variations[0].variations)"
                                                        :key="index"
                                                        :value="`${variation.name}-${variation.sale_price || variation.price}`">
                                                        {{ variation.name }} (₦
                                                        {{ variation.sale_price || variation.price }})
                                                    </option>
                                                </select></div>
                                            <div class="col-md-3"
                                                 v-if="isEditing && item.product && item.product.product_type === 'variable' && item.product.product.product_variations && item.product.product.product_variations.length > 0">
                                                <label> Choose {{
                                                        item.product.product.product_variations[0].variable_name
                                                    }} </label> <select class="form-control" required
                                                                        @change="setVariableCost(index)"
                                                                        v-model="item.selected_variation">
                                                <option> Select
                                                    {{ item.product.product.product_variations[0].variable_name }}
                                                </option>
                                                <option
                                                    v-for="(variation, index) in parseJson(item.product.product.product_variations[0].variations)"
                                                    :key="index"
                                                    :value="`${variation.name}-${variation.sale_price || variation.price}`">
                                                    {{ variation.name }} (₦ {{
                                                        variation.sale_price || variation.price
                                                    }})
                                                </option>
                                            </select></div>
                                            <div class="col-md-3">
                                                <div class="form-group"><label>Quantity</label> <br> <input
                                                    v-model="item.quantity" type="number" class="form-control"
                                                    placeholder="Quantity" required></div>
                                            </div>
                                            <div class="col-md-3"
                                                 v-if="!item.product || (item.product && item.product.product_type === 'simple')"></div>
                                            <div class="col-md-3 variant-actions mb-3"><a href="#"
                                                                                          @click.prevent="addNewRow(index)">
                                                <i class="feather icon-plus-circle"></i> Add </a> | <a href="#"
                                                                                                       @click.prevent="removeRow(index)"
                                                                                                       class="text-danger">
                                                <i class="feather icon-minus-circle"></i> Remove </a></div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                                :disabled="isLoading"> Save changes <i class="fa fa-spinner spinner"
                                                                                       v-if="isLoading"></i></button>
                                    </div>
                                </form>
                                <div class="table-responsive"
                                     v-if="!showOrderItems && (isEditing || (order.order_type && order.restaurant && order.latitude && order.longitude && !outOfCoverageMessage))">
                                    <table id="users-list-datatable" class="table">
                                        <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th width="100px">Product image</th>
                                            <th>Product</th>
                                            <th>Cost (₦)</th>
                                            <th>Quantity</th>
                                            <th class="text-right">Total (₦)</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in order.order_items" :key="item.id">
                                            <template v-if="item.product">
                                                <td>{{ index + 1 }}</td>
                                                <td>
                                                    <viewer :images="[item.product.product.image_url]"><img
                                                        :src="item.product.product.image_url"
                                                        class="img-fluid cursor-pointer"></viewer>
                                                </td>
                                                <td><span v-if="item.product.product_type === 'simple'"> {{
                                                        item.product.product.product
                                                    }} </span> <span v-else> {{
                                                        item.product.product.product
                                                    }} ({{ item.selected_variation }}) </span></td>
                                                <td><span v-if="item.product.product_type === 'simple'"> {{
                                                        formatNumber(item.product.sale_price || item.product.price || item.product.product.price)
                                                    }} </span> <span v-else> {{
                                                        formatNumber(item.variable_cost)
                                                    }} </span></td>
                                                <td>{{ item.quantity }}</td>
                                                <td class="text-right"> {{ formatNumber(item.subtotal) }}</td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="4">Subtotal</td>
                                            <td class="text-right">₦ {{ formatNumber(subTotal) }}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="4">Shipping:</td>
                                            <td class="text-right"> ₦ {{ formatNumber(shippingFee) }}</td>
                                        </tr>
                                        <tr v-if="order.discount">
                                            <td></td>
                                            <td colspan="4">Coupon ({{ order.coupon }})</td>
                                            <td class="text-right"></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <th colspan="4">Total</th>
                                            <th class="text-right">₦{{ formatNumber(total) }}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button type="submit" class="btn btn-primary glow float-right mb-1 mb-sm-0 mr-0"
                                        v-if="!showOrderItems && (order.order_type && order.restaurant && order.latitude && order.longitude && !outOfCoverageMessage)"
                                        :disabled="!order.order_items[0].quantity || isLoadingOrder">
                                    {{ isEditing ? 'Update Order' : 'Create Order' }} <i class="fa fa-spinner spinner"
                                                                                         v-if="isLoadingOrder"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal fade text-left" id="items-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <form @submit.prevent="addItems">
                        <div class="modal-header"><h4 class="modal-title">Add Products</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body" v-if="order.restaurant">
                            <div class="row" v-for="(item, index) in order.order_items" :key="item.id">
                                <div class="col-md-3">
                                    <div class="form-group"><label>Product</label> <br>
                                        <v-select class="order-items-search" label="name" v-model="item.product"
                                                  :options="restaurantProducts">
                                            <template slot="no-options"> Choose Product</template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center" v-if="option.product.product_type === 'simple'">
                                                    <img :src="option.product.image_url" width="40px"> <span
                                                    class="ml-1">{{ option.product.product }}</span> <span class="ml-1"> ₦ {{
                                                        formatNumber(getProductPrice(option))
                                                    }} </span></div>
                                                <div class="d-center" v-else><img :src="option.product.image_url"
                                                                                  width="40px"> <span
                                                    class="ml-1">{{ option.product.product }}</span></div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center"><img :src="option.product.image_url"
                                                                                    height="28px"> <span
                                                    class="ml-1">{{ option.product.product }}</span></div>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-3"
                                     v-if="item.product && item.product.product_type === 'variable' && item.product.product.product_variations && item.product.product.product_variations.length > 0">
                                    <label> Choose {{
                                            item.product.product.product_variations[0].variable_name
                                        }} </label> <select class="form-control" @change="setVariableCost(index)"
                                                            v-model="item.selected_variation">
                                    <option> Select {{
                                            item.product.product.product_variations[0].variable_name
                                        }}
                                    </option>
                                    <option
                                        v-for="(variation, index) in parseJson(item.product.product.product_variations[0].variations)"
                                        :key="index"
                                        :value="`${variation.name}-${variation.sale_price || variation.price}`">
                                        {{ variation.name }} (₦ {{ variation.sale_price || variation.price }})
                                    </option>
                                </select></div>
                                <div class="col-md-3">
                                    <div class="form-group"><label>Quantity</label> <br> <input v-model="item.quantity"
                                                                                                type="number"
                                                                                                class="form-control"
                                                                                                placeholder="Quantity"
                                                                                                required></div>
                                </div>
                                <div class="col-md-3"
                                     v-if="!item.product || (item.product && item.product.product_type === 'simple')"></div>
                                <div class="col-md-3 variant-actions mb-3"><a href="#"
                                                                              @click.prevent="addNewRow(index)"> <i
                                    class="feather icon-plus-circle"></i> Add </a> | <a href="#"
                                                                                        @click.prevent="removeRow(index)"
                                                                                        class="text-danger"> <i
                                    class="feather icon-minus-circle"></i> Remove </a></div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal"> Close
                            </button>
                            <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                    :disabled="isLoading"> Save changes <i class="fa fa-spinner spinner"
                                                                           v-if="isLoading"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
// import Switches from "vue-switches";
import Layout from '@/Shared/Layout';

export default {
    props: ["dataCities", "dataPaymentMethods", "dataRestaurants", "dataOrder", "isEditing", 'dataUser'],
    components: { // VueGoogleAutocomplete,
        // Switches
    },
    layout: Layout,
    data: () => ({
        showAddressInput: true,
        field1: '',
        order: {
            payment_method: '',
            order_items: [{quantity: '', product_id: ''}],
            customer: {first_name: '', last_name: '', house_number: ''},
            recipient: {first_name: '', last_name: '', house_number: ''},
            order_type: 'delivery'
        },
        customers: [],
        newCustomer: false,
        cities: [],
        paymentMethods: [],
        isLoading: false,
        isLoadingOrder: false,
        restaurants: [],
        restaurantProducts: [],
        shippingFee: 0,
        outOfCoverageMessage: '',
        user: {},
        restaurant: {},
        hasLocation: false,
        oldRestaurantId: null,
        paymentMethodError: false,
        showOrderItems: false,
        updateRecipient: false
    }),
    watch: {
        newCustomer() {
            this.order.customer = {first_name: '', last_name: ''};
        },
        order: {
            async handler(val) {
                const newRestaurantId = val.restaurant.id;
                if ((!this.oldRestaurantId && newRestaurantId) || (this.oldRestaurantId !== newRestaurantId)) {
                    if (!this.order.longitude) return;
                    if (!this.isEditing) {
                        this.order.order_items = [{quantity: '', product_id: ''}];
                    }
                    this.oldRestaurantId = newRestaurantId;
                    await this.fetchRestaurantProduct(newRestaurantId);
                }
            }, deep: true
        }, hasSelectedCustomer(data) {
            if (data && !this.isEditing) {
                const customer = this.order.customer;
                this.order.recipient = {...customer}
            }
        }, orderType(type) {
            if ((type === 'delivery' && this.hasLocation && this.order.restaurant) || (type === 'pickup' && this.hasLocation && this.order.restaurant)) {
                this.fetchRestaurantProduct(this.order.restaurant.id)
            }
        }
    },
    created() {
        this.cities = this.dataCities ? JSON.parse(this.dataCities) : [];
        this.restaurants = this.dataRestaurants ? JSON.parse(this.dataRestaurants) : [];
        this.paymentMethods = this.dataPaymentMethods ? JSON.parse(this.dataPaymentMethods) : [];
        if (this.isEditing) {
            this.newCustomer = false;
        } else {
            this.updateRecipient = true;
        }
        if (this.dataOrder) {
            this.order = JSON.parse(this.dataOrder);
            this.shippingFee = +this.order.delivery;
            this.fetchRestaurantProduct(this.order.restaurant.id);
        }
        this.user = JSON.parse(this.dataUser);
        if (this.user.user_type === 'store manager') {
            this.order.restaurant = this.restaurants.find(x => x.id === +this.user.restaurant_id);
            this.restaurant = this.order.restaurant;
        }
    },
    mounted() {
        if (this.isEditing) {
            // this.$refs.autocomplete.update(this.order.ship_to);
            this.order.customer.city_id = '';
            this.order.customer.street = this.order.ship_to;
            this.order.street = this.order.ship_to;
            this.order.created_at = this.order.created_at_formatted;
            this.field1 = this.order.ship_to;
            this.showAddressInput = false;
        }
    }, methods: {
        addressAutocompleteSearch(place, address) {
            let country = '';
            let state = '';
            let locality = '';
            let route = place.structured_formatting.main_text;
            address.address_components.forEach(addr => {
                if (addr.types.includes('country')) {
                    country = addr.long_name;
                }
                if (addr.types.includes('administrative_area_level_1')) {
                    state = addr.long_name;
                }
                if (addr.types.includes("locality")) {
                    locality = addr.long_name;
                }
            })
            const longitude = address.geometry.location.lng();
            const latitude = address.geometry.location.lat();
            this.showAddressInput = false;
            this.getAddressData({longitude, latitude, country, locality, route})
        }, editAddress() {
            this.showAddressInput = true;
        }, async fetchRestaurantProduct(restaurant_id) {
            const {
                data: {
                    products,
                    distance,
                    delivery_price
                }
            } = await axios.get(`/admin/restaurants/${restaurant_id}/products?longitude=${this.order.longitude}&latitude=${this.order.latitude}`);
            this.outOfCoverageMessage = '';
            if (delivery_price == null) {
                this.outOfCoverageMessage = 'Selected Location is out of coverage!';
                return;
            }
            this.restaurantProducts = products.map(product => ({...product, name: product.product.product}));
            if (this.order.order_type === 'delivery') {
                this.shippingFee = delivery_price || 0;
            } else {
                this.shippingFee = 0;
            } // this.shippingFee = delivery_price || 0;
        }, onSearch(search, loading) {
            if (search.length > 5) {
                loading(true);
                this.search(loading, search, this);
            }
        }, search: _.debounce((loading, search, vm) => {
            axios.get(`/admin/users/search?name=${escape(search)}`).then(({data: {data}}) => {
                vm.customers = data;
                loading(false);
            });
        }, 1000), addNewRow(index) {
            this.order.order_items.splice(index + 1, 0, {product_id: '', quantity: ''})
        }, removeRow(index) {
            this.order.order_items.splice(index, 1);
            if (this.order.order_items.length === 0) {
                this.order.order_items = [{product_id: '', quantity: ''}]
            }
        },
        async getAddressData({longitude, latitude, country, locality, route}) {
            this.order.latitude = latitude;
            this.order.longitude = longitude;
            this.order.street = `${route}, ${locality}, ${country}`;
            if (this.user.user_type === 'store manager') {
                if (!this.isEditing) {
                    this.order.order_items = [{quantity: '', product_id: ''}];
                }
                await this.fetchRestaurantProduct(this.restaurant.id);
            }
            this.hasLocation = true;
            if (this.order.restaurant) {
                const {
                    data: {
                        distance,
                        delivery_price
                    }
                } = await axios.post(`/admin/restaurants/${this.order.restaurant.id}/calculate-shipping`, this.order);
                this.outOfCoverageMessage = '';
                if (!delivery_price) {
                    this.outOfCoverageMessage = 'Selected Location is out of coverage!';
                    return;
                }
                this.shippingFee = delivery_price;
            }
        }, formatNumber(x) {
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        }, getProductPrice(restaurantProduct) {
            if (restaurantProduct.product.product_type === 'simple') {
                if (restaurantProduct.sale_price) {
                    return restaurantProduct.sale_price;
                }
                if (restaurantProduct.product.sale_price) {
                    return restaurantProduct.product.sale_price;
                }
                if (restaurantProduct.price) {
                    return restaurantProduct.price;
                }
                return restaurantProduct.product.price;
            }
            return 0;
        }, parseJson(item) {
            return JSON.parse(item);
        }, addItems() {
            this.order.order_items = this.order.order_items.map(item => {
                const itemPrice = item.product.product_type === 'simple' ? (item.product.sale_price || item.product.price || item.product.product.price) : item.variable_cost;
                return {...item, cost: itemPrice, subtotal: +itemPrice * item.quantity}
            });
            this.showOrderItems = false; // $('#items-modal').modal('hide');
        }, getProductWithVariationName(orderItem) {
            return orderItem.product.product.product_variations.map(x => x.selected_variation).join(', ');
        }, setVariableCost(index) {
            this.order.order_items[index].variable_cost = this.order.order_items[index].selected_variation.split('-')[1];
        }, async updateOrder() {
            this.paymentMethodError = false;
            if (!this.order.payment_method) return this.paymentMethodError = true;
            this.isLoadingOrder = true;
            try {
                const {data} = await axios.patch(`/admin/orders/${this.order.id}/update-order`, {
                    ...this.order,
                    total: this.total,
                    subtotal: this.subTotal,
                    delivery: this.shippingFee,
                    quantity: this.order.order_items.reduce((accumulator, currentValue) => accumulator + +currentValue.quantity, 0),
                    new_customer: this.newCustomer,
                    recipient: {
                        email: this.order.recipient.email,
                        first_name: this.order.recipient.first_name,
                        last_name: this.order.recipient.last_name,
                        phone: this.order.recipient.phone,
                    }
                });
                this.isLoadingOrder = false;
                this.$store.commit('notifier/showNotifier', {message: 'Order updated successfully!', type: 'success'});
            } catch (e) {
                this.$store.commit('notifier/showNotifier', {message: e.response.data.message, type: 'danger'});
                this.isLoadingOrder = false;
            }
        }, async createOrder() {
            this.isLoadingOrder = true;
            try {
                const {data} = await axios.post(`/admin/orders`, {
                    ...this.order,
                    total: this.total,
                    subtotal: this.subTotal,
                    delivery: this.shippingFee,
                    quantity: this.order.order_items.reduce((accumulator, currentValue) => accumulator + +currentValue.quantity, 0),
                    new_customer: this.newCustomer
                });
                this.isLoadingOrder = false;
                this.$store.commit('notifier/showNotifier', {message: data.message, type: 'success'});
                location.href = '/admin/orders';
            } catch (e) {
                this.$store.commit('notifier/showNotifier', {message: e.response.data.message, type: 'danger'});
                this.isLoadingOrder = false;
            }
        }
    }, computed: {
        subTotal() {
            let initialValue = 0;
            if (this.order.restaurant) {
                return this.order.order_items.reduce((accumulator, currentValue) => {
                    let currCost = currentValue.subtotal ? +currentValue.subtotal : 0;
                    return accumulator + currCost;
                }, initialValue);
            }
            return 0;
        }, total() {
            return this.subTotal + this.shippingFee;
        }, hasSelectedCustomer() {
            return !!this.order.customer.first_name;
        }, orderType() {
            return this.order.order_type;
        }
    }
}
</script>
<style>.new-customer {
    padding-top: 7px;
} </style>
<style scoped>.variant-actions {
    margin-top: 35px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.address-input {
    position: relative;
}

.address-change {
    position: absolute;
    top: 50%;
    right: 0
}

form .form-group {
    margin-bottom: 1.5rem;
}

form label {
    color: #2E405C;
}

label, output {
    display: inline-block;
}
dd, h1, h2, h3, h4, h5, h6, label {
    margin-bottom: 0.5rem;
}
fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
}
.card-group__title {
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    background-color: #fff;
    padding: 0 7px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 2px;
}

.card-group {
    border: 1px solid #98a4b8;
    margin-bottom: 30px;
}
</style>
